import React, { useMemo, useCallback } from "react";

const DynamicCommentGrid = ({
  count,
  extraEntries = [],
  values,
  onChange,
  labels,
  names,
  disabledFields = [],
  highlightedFields = [],
  onLabelDoubleClick,
  onFieldBlur,
}) => {
  const baseBoxes = useMemo(
    () => Array.from({ length: count }, (_, i) => i),
    [count]
  );

  const disabledSet = useMemo(() => new Set(disabledFields || []), [disabledFields]);
  const highlightedSet = useMemo(
    () => new Set(highlightedFields || []),
    [highlightedFields]
  );

  const labelClickableStyle = useMemo(
    () => ({
      cursor: "pointer",
      userSelect: "none",
    }),
    []
  );

  const handleInputChange = useCallback(
    (name, value) => {
      onChange?.(name, value);
    },
    [onChange]
  );

  const handleLabelDoubleClick = useCallback(
    (name, label) => {
      onLabelDoubleClick?.(name, label);
    },
    [onLabelDoubleClick]
  );

  const handleBlur = useCallback(
    (name) => {
      onFieldBlur?.(name);
    },
    [onFieldBlur]
  );

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(110px, 1fr))",
        gap: 12,
        alignItems: "start",
      }}
    >
      {baseBoxes.map((i) => {
        const name = names?.[i] || `txtDynamic${i + 1}`;
        const label = labels?.[i] || `+${i + 1}`;
        const isDisabled = disabledSet.has(name);
        const isHighlighted = highlightedSet.has(name);

        return (
          <div
            key={name}
            style={{
              border: "1px solid #e9ecef",
              borderRadius: 10,
              padding: 10,
              background: isHighlighted ? "#fff5f5" : "#fff",
              boxShadow: "0 1px 0 rgba(0,0,0,0.03)",
              opacity: isDisabled ? 0.65 : 1,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "space-between",
                marginBottom: 6,
              }}
            >
              <div
                style={{ fontWeight: 700, fontSize: 13, ...labelClickableStyle }}
                onDoubleClick={() => handleLabelDoubleClick(name, label)}
                title="Double-click to Supervisor Override (if enabled)"
              >
                {label}
              </div>

              {isHighlighted ? (
                <span
                  style={{ fontSize: 11, color: "#dc3545", fontWeight: 600 }}
                >
                  OUT
                </span>
              ) : (
                <span style={{ fontSize: 11, color: "#adb5bd" }}> </span>
              )}
            </div>

            <input
              id={name}
              type="text"
              value={values[name] || ""}
              onChange={(e) => handleInputChange(name, e.target.value)}
              onBlur={() => handleBlur(name)}
              disabled={isDisabled}
              style={{
                width: "100%",
                padding: "8px 10px",
                borderRadius: 8,
                border: "1px solid #ced4da",
                outline: "none",
              }}
            />
          </div>
        );
      })}

      {extraEntries.map((entry) => {
        const name = entry?.name;
        if (!name) return null;

        const label = entry?.label;
        const isDisabled = disabledSet.has(name);
        const isHighlighted = highlightedSet.has(name);

        return (
          <div
            key={name}
            style={{
              border: "1px dashed #cfe2ff",
              borderRadius: 10,
              padding: 10,
              background: isHighlighted ? "#fff5f5" : "#f8fbff",
              boxShadow: "0 1px 0 rgba(0,0,0,0.03)",
              opacity: isDisabled ? 0.65 : 1,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "space-between",
                marginBottom: 6,
              }}
            >
              <div
                style={{ fontWeight: 700, fontSize: 13, ...labelClickableStyle }}
                onDoubleClick={() => handleLabelDoubleClick(name, label)}
                title="Double-click to Supervisor Override (if enabled)"
              >
                {label}
              </div>
              <span style={{ fontSize: 11, color: "#6c757d" }}>ADDED</span>
            </div>

            <input
              id={name}
              type="text"
              value={values[name] || ""}
              onChange={(e) => handleInputChange(name, e.target.value)}
              onBlur={() => handleBlur(name)}
              disabled={isDisabled}
              style={{
                width: "100%",
                padding: "8px 10px",
                borderRadius: 8,
                border: "1px solid #ced4da",
                outline: "none",
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(DynamicCommentGrid);